import dayjs from "dayjs";

import { BenchmarkGranularity } from "app/common/benchmark/constants";

import { TrendTooltip } from "./styles";

type ShareTooltipSchema = {
    timestamp: string | number;
    value: number;
    granularity: BenchmarkGranularity;
    formatter?: (val: number) => string;
};

export const ShareTooltip = ({ timestamp, value, granularity, formatter }: ShareTooltipSchema) => {
    const formattedValue = formatter?.(value) || value;
    const format = granularity === BenchmarkGranularity.MONTHLY ? "MMMM YYYY" : "MMMM DD, YYYY";

    const date = dayjs(timestamp).format(format);

    return (
        <TrendTooltip>
            <span>{date}</span> <span>{formattedValue}</span>
        </TrendTooltip>
    );
};
